import React from 'react';
import { Handle, Position } from 'reactflow';
import NodeSymbolSelect from './NodeSymbolSelect';

export default function PriceNode({ data, id }) {
  const onChange = (field, value) => {
    if (data.onChange) data.onChange(id, field, value);
  };

  return (
    <div style={{
      padding: 12,
      borderRadius: 8,
      border: '2px solid #8b5cf6',
      background: 'var(--card)',
      minWidth: 140,
      fontSize: 13,
      color: 'var(--text)',
    }}>
      <div style={{ fontWeight: 700, marginBottom: 8, color: '#a78bfa' }}>
        💲 Price
      </div>
      <NodeSymbolSelect value={data.symbol} onChange={(v) => onChange('symbol', v)} />
      <select
        value={data.field || 'close'}
        onChange={(e) => onChange('field', e.target.value)}
        style={{ width: '100%', padding: 4, background: 'var(--surface)', color: 'var(--text)', border: '1px solid var(--border)', borderRadius: 4 }}
      >
        <option value="close">Close</option>
        <option value="open">Open</option>
        <option value="high">High</option>
        <option value="low">Low</option>
      </select>
      <Handle type="source" position={Position.Right} id="output" style={{ background: '#8b5cf6' }} />
    </div>
  );
}
